import React, { useEffect, useState } from 'react'
// import localStorage from 'local-storage'
import { SESSION_STORAGE_KEY, DEFAULT_LANGUAGE, LOCAL_STORAGE_KEY, LANGUAGES } from '../../utils/constant'
import { emitGA } from '../../utils/gtm'
import { getConfig } from '../../utils/index'
import { subscribeFB } from '../../utils/facebook'
import { isMobile } from 'react-device-detect'
import MessengerCustomerChat from 'react-messenger-customer-chat'
import { withTranslation } from '../../i18n'

export const MessengerChat = ({ t, routeName }) => {
  const facebookPageID = getConfig('REACT_APP_FB_PAGE_ID')
  const [currentLanguage, setCurrentLanguage] = useState(DEFAULT_LANGUAGE)
  const message = t`Xin chào anh/chị, em có thể giúp gì cho anh chị không ạ?`

  const handleCustomerChatShow = () => {
    const auto = sessionStorage.getItem(SESSION_STORAGE_KEY.AUTO)
    emitGA('CLICK_CHAT_ICON', { action: 'MessengerIcon', which: auto === '0' ? null : 'Auto' })
    auto > 0 && sessionStorage.setItem(SESSION_STORAGE_KEY.AUTO, auto)
  }

  useEffect(() => {
    const langCode = localStorage.getItem(LOCAL_STORAGE_KEY.LANG) || DEFAULT_LANGUAGE
    if (LANGUAGES[langCode]) {
      setCurrentLanguage(LANGUAGES[langCode].countryCode)
    }
    subscribeFB('customerchat.dialogShow', handleCustomerChatShow)
  })

  return !isMobile && process.browser &&
    <MessengerCustomerChat
      language={currentLanguage}
      shouldShowDialog={ routeName === 'home' }
      themeColor="#0084FF"
      pageId={facebookPageID}
      appId=""
      loggedInGreeting={message}
      loggedOutGreeting={message}
      htmlRef={window.location.pathname}
    />
}

export default withTranslation('common')(MessengerChat)
